import { VChipGroup } from 'vuetify/lib/components/VChipGroup';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        VChipGroup,
        [
          _c("FiltersButton", {
            attrs: {
              label: "Услуга",
              icon: "ui-icon-doctor",
              "active-num": _vm.serviceFilters.getAppliedNum(),
              "reset-handler": _vm.handleServiceFiltersReset,
            },
            on: {
              click: function ($event) {
                return _vm.openDialog("service")
              },
            },
          }),
          _vm._v(" "),
          _c("FiltersButton", {
            attrs: {
              label: "Место",
              icon: "ui-icon-map-pin",
              "active-num": _vm.placeFilters.getAppliedNum(),
              "reset-handler": _vm.handlePlaceFiltersReset,
            },
            on: {
              click: function ($event) {
                return _vm.openDialog("regions")
              },
            },
          }),
          _vm._v(" "),
          _vm._t("map-button", null, null, { classes: ["ml-auto"] }),
        ],
        2
      ),
      _vm._v(" "),
      _c("service-filters-service", {
        staticClass: "filters-button",
        attrs: {
          active: _vm.anyServiceFilterApplied,
          filters: _vm.serviceFilters,
          open: _vm.isTopDialog("service"),
        },
        on: {
          "filters:submit": _vm.handleServiceFiltersSubmit,
          "filters:reset": _vm.handleServiceFiltersReset,
          "filters:close": _vm.handleServiceFiltersClose,
        },
      }),
      _vm._v(" "),
      _c("common-filters-place", {
        staticClass: "filters-button ml-4",
        attrs: {
          active: _vm.anyPlaceFilterApplied,
          filters: _vm.placeFilters,
          open: _vm.isTopDialog("regions"),
        },
        on: {
          "filters:submit": _vm.handlePlaceFiltersSubmit,
          "filters:reset": _vm.handlePlaceFiltersReset,
          "filters:close": _vm.handlePlaceFiltersClose,
        },
      }),
      _vm._v(" "),
      _c("snackbar-notification", {
        attrs: {
          upper: _vm.notificationUpper,
          message: _vm.notificationMessage,
        },
        model: {
          value: _vm.notification,
          callback: function ($$v) {
            _vm.notification = $$v
          },
          expression: "notification",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }